import { queryClient } from "shared-utils";

import { insightsRouteDataQuery, internalInsightsRouteDataQuery } from "./utils/route-data-query";

export type InsightsLoaderReturn = {
  customerDomain: string;
};

export const insightsLoader = ({ params }): InsightsLoaderReturn => {
  void queryClient.prefetchQuery(insightsRouteDataQuery(params.customerDomain));
  return { customerDomain: params.customerDomain };
};

export const internalInsightsLoader = ({ params }): InsightsLoaderReturn => {
  void queryClient.prefetchQuery(internalInsightsRouteDataQuery(params.customerDomain));
  return { customerDomain: params.customerDomain };
};
